export default __webpack_public_path__ + "static/media/activity2.c6685e80.png";